import { Switch, Redirect, Route } from "react-router-dom";

import { clientUrls } from "misc/urls/clientUrls";
import { CheckAppPermissions } from "misc/authentication";
import { UserManagementRoles } from "misc/roles";

import { Card } from "misc/card";
import { Result } from "misc/results";
import CustomerComponent from "admin/components/CustomerComponent";
import CustomersListComponent from "admin/components/CustomersListComponent";
import { useCustomers } from "misc/api/keycloakApi";

const CustomerContainer = () => {
    // Prefetching
    useCustomers({ suspense: true });

    return (
        <CheckAppPermissions
            fallback={
                <Card>
                    <Result type="unauthorizedAccess" />
                </Card>
            }
            allowed={[UserManagementRoles.PermissionAuthorityFull]}
        >
            <Switch>
                <Route exact path={clientUrls.customers.baseUrl()} component={CustomersListComponent} />
                <Route exact path={clientUrls.customers.edit()} component={CustomerComponent} />
                <Route exact path={clientUrls.customers.create()} component={CustomerComponent} />
                <Redirect to={clientUrls.customers.baseUrl()} />
            </Switch>
        </CheckAppPermissions>
    );
};

export default CustomerContainer;
